import HomeVariants from './HomeVariants';

export default HomeVariants;
